import React from 'react';
import Home from './Components/Home';
import About from './Components/About';
import Service from './Components/Service';
import Contact from './Components/Contact';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import './App.css';
import { Switch, Route, Redirect } from 'react-router-dom';
import NavBar from './Components/NavBar';
import Footer from './Components/footer';
import Dashboard from './Components/Dashboard';
import Regional from './Components/Regional';
import Testing from './Components/Testing';
import GraphBoard from "./Components/GraphBoard";
import Hospital from './Components/Hospital';
import Notifications from './Components/Notifications';
import HelpLine from './Components/HelpLine';
import DataMonitor from './Components/DataMonitor';
import WorldData from './Components/WorldData';
import MedicalClg from './Components/MedicalClg';

function App() {
  return (
    <>
      <NavBar/>
      <Switch>
        <Route exact path="/" component={Home}/>
        <Route exact path="/about" component={About}/>
        <Route exact path="/data" component={Service}/>
        <Route exact path="/contact" component={Contact}/>
        <Route exact path="/Dashboard" component={Dashboard}/>
        <Route exact path="/RegionalData" component={Regional}/>
        <Route exact path="/TestUpdate" component={Testing}/>
        <Route exact path="/Tracker" component={GraphBoard}/>
        <Route exact path="/Hospital" component={Hospital}/>
        <Route exact path="/Notifications" component={Notifications}/>
        <Route exact path="/HelpLine" component={HelpLine}/>
        <Route exact path="/data-monitor" component={DataMonitor}/>
        <Route exact path="/world-updates" component={WorldData}/>
        <Route exact path="/MedialClg" component={MedicalClg}/>
        <Route exact path="*" component={Home}/>


        <Redirect to="/"/>
     </Switch>
     <Footer/>
    </>
  );
}

export default App;
